import { render, staticRenderFns } from "./PurchasesModuleLayout.vue?vue&type=template&id=749cba59&"
import script from "./PurchasesModuleLayout.vue?vue&type=script&lang=js&"
export * from "./PurchasesModuleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports